import { accent } from "../hooks/tokens.js";
import { DIAGRAMS, ARTICLES } from "../data.js";

// Schémas de référence (spine-leaf, campus, WAN hybride) avec calques
// filtrables par légende.
export function buildDiagramsView(ctx) {
  const { s, patch, go } = ctx;
  const d = DIAGRAMS.find((x) => x.id === s.diagramId) || DIAGRAMS[0];
  const target = ARTICLES.find((a) => a.id === d.article);
  const dim = (key) => s.diagramKey && s.diagramKey !== key;

  return {
    diagramTabs: DIAGRAMS.map((x) => ({ label: x.label,
      border: x.id === s.diagramId ? accent : "oklch(0.92 0.008 85)",
      color: x.id === s.diagramId ? accent : "oklch(0.45 0.015 60)",
      bg: x.id === s.diagramId ? "oklch(0.99 0.006 60)" : "transparent",
      onClick: () => patch({ diagramId: x.id, diagramKey: null }) })),
    diagramLayers: d.layers.map((l) => ({
      name: l.name, opacity: dim(l.key) ? "0.32" : "1",
      hasLink: !!l.linkLabel, linkLabel: l.linkLabel || "",
      risers: l.nodes.map((_, j) => ({ i: j })),
      nodes: l.nodes.map((n) => ({ label: n.label, sub: n.sub,
        border: s.diagramKey === l.key ? accent : "oklch(0.9 0.01 85)",
        bg: s.diagramKey === l.key ? "oklch(0.99 0.006 60)" : "oklch(1 0 0)",
        color: "oklch(0.26 0.015 60)",
        onClick: () => patch({ diagramKey: s.diagramKey === l.key ? null : l.key }) })),
    })),
    diagramLegend: d.legend.map((g) => ({ name: g.name, desc: g.desc,
      dot: s.diagramKey === g.key ? accent : "oklch(0.82 0.012 85)",
      color: s.diagramKey === g.key ? accent : "oklch(0.3 0.015 60)",
      onClick: () => patch({ diagramKey: s.diagramKey === g.key ? null : g.key }) })),
    diagramNote: d.note,
    diagramArticleLabel: target ? "Fiche associée : " + target.title : "",
    diagramArticle: () => { if (target) go(target.id); },
  };
}
